/* tslint:disable */
/* eslint-disable */
/**
 * GateHouse AIS REST interface
 * AIS system for monitoring vessel traffic. Commercial WebService. Contact GateHouse support for more information.
 *
 * The version of the OpenAPI document: 0.2.2
 * Contact: support@gatehouse.dk
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


import * as runtime from '../runtime';
import type {
  AnchorageCallsGet200Response,
  PortCallsGet200Response,
  PortExtended,
  PortHistoryNameGet200Response,
  PortListGet200Response,
  ShipRegisterGet200Response,
  StandardResponse,
  TrackGet200Response,
} from '../models';
import {
    AnchorageCallsGet200ResponseFromJSON,
    AnchorageCallsGet200ResponseToJSON,
    PortCallsGet200ResponseFromJSON,
    PortCallsGet200ResponseToJSON,
    PortExtendedFromJSON,
    PortExtendedToJSON,
    PortHistoryNameGet200ResponseFromJSON,
    PortHistoryNameGet200ResponseToJSON,
    PortListGet200ResponseFromJSON,
    PortListGet200ResponseToJSON,
    ShipRegisterGet200ResponseFromJSON,
    ShipRegisterGet200ResponseToJSON,
    StandardResponseFromJSON,
    StandardResponseToJSON,
    TrackGet200ResponseFromJSON,
    TrackGet200ResponseToJSON,
} from '../models';

export interface AnchorageCallsGetRequest {
    locode?: string;
    anchorage?: string;
    imo?: number;
    mmsi?: number;
    begin?: Date;
    end?: Date;
}

export interface PortArrivalsIdGetRequest {
    id: number;
}

export interface PortCallsGetRequest {
    locode?: string;
    imo?: number;
    mmsi?: number;
    begin?: Date;
    end?: Date;
}

export interface PortHistoryNameGetRequest {
    name: string;
    begin?: Date;
    end?: Date;
}

export interface PortInfoIdDeleteRequest {
    id: number;
}

export interface PortInfoIdGetRequest {
    id: string;
}

export interface PortInfoIdPutRequest {
    id: number;
    portExtended: PortExtended;
}

export interface PortInfoPostRequest {
    portExtended: PortExtended;
}

export interface PortListGetRequest {
    pattern?: string;
    offset?: number;
    limit?: number;
    dc?: number;
    nextport?: boolean;
}

export interface ShipRegisterMmsiDeleteRequest {
    mmsi: number;
}

/**
 * 
 */
export class PortApi extends runtime.BaseAPI {

    /**
     * Get a list of vessels currently at anchor at the anchorage for a given port. The call supports using a locode for any anchorage area associated with a port. Notice that at least one of the parameters mmsi, imo, locode or anchorage must be provided 
     * Get a list of vessels currently at anchor at the anchorage for a given port
     */
    async anchorageCallsGetRaw(requestParameters: AnchorageCallsGetRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<AnchorageCallsGet200Response>> {
        const queryParameters: any = {};

        if (requestParameters.locode !== undefined) {
            queryParameters['locode'] = requestParameters.locode;
        }

        if (requestParameters.anchorage !== undefined) {
            queryParameters['anchorage'] = requestParameters.anchorage;
        }

        if (requestParameters.imo !== undefined) {
            queryParameters['imo'] = requestParameters.imo;
        }

        if (requestParameters.mmsi !== undefined) {
            queryParameters['mmsi'] = requestParameters.mmsi;
        }

        if (requestParameters.begin !== undefined) {
            queryParameters['begin'] = (requestParameters.begin as any).toISOString();
        }

        if (requestParameters.end !== undefined) {
            queryParameters['end'] = (requestParameters.end as any).toISOString();
        }

        const headerParameters: runtime.HTTPHeaders = {};

        if (this.configuration && (this.configuration.username !== undefined || this.configuration.password !== undefined)) {
            headerParameters["Authorization"] = "Basic " + btoa(this.configuration.username + ":" + this.configuration.password);
        }
        const response = await this.request({
            path: `/anchorage/calls`,
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => AnchorageCallsGet200ResponseFromJSON(jsonValue));
    }

    /**
     * Get a list of vessels currently at anchor at the anchorage for a given port. The call supports using a locode for any anchorage area associated with a port. Notice that at least one of the parameters mmsi, imo, locode or anchorage must be provided 
     * Get a list of vessels currently at anchor at the anchorage for a given port
     */
    async anchorageCallsGet(requestParameters: AnchorageCallsGetRequest = {}, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<AnchorageCallsGet200Response> {
        const response = await this.anchorageCallsGetRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * Get the current status of the tracks of the ships towards the destination. Returns the ETA.
     * Get status of arrivals for all ships towards a port
     */
    async portArrivalsIdGetRaw(requestParameters: PortArrivalsIdGetRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<TrackGet200Response>> {
        if (requestParameters.id === null || requestParameters.id === undefined) {
            throw new runtime.RequiredError('id','Required parameter requestParameters.id was null or undefined when calling portArrivalsIdGet.');
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        if (this.configuration && (this.configuration.username !== undefined || this.configuration.password !== undefined)) {
            headerParameters["Authorization"] = "Basic " + btoa(this.configuration.username + ":" + this.configuration.password);
        }
        const response = await this.request({
            path: `/port/arrivals/{id}`.replace(`{${"id"}}`, encodeURIComponent(String(requestParameters.id))),
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => TrackGet200ResponseFromJSON(jsonValue));
    }

    /**
     * Get the current status of the tracks of the ships towards the destination. Returns the ETA.
     * Get status of arrivals for all ships towards a port
     */
    async portArrivalsIdGet(requestParameters: PortArrivalsIdGetRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<TrackGet200Response> {
        const response = await this.portArrivalsIdGetRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * Get a list of port calls for one or more ports or a vessel. Notice that at least one of the parameters mmsi, imo or locode must be provided 
     * Get a list port calls for a given port or vessel
     */
    async portCallsGetRaw(requestParameters: PortCallsGetRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<PortCallsGet200Response>> {
        const queryParameters: any = {};

        if (requestParameters.locode !== undefined) {
            queryParameters['locode'] = requestParameters.locode;
        }

        if (requestParameters.imo !== undefined) {
            queryParameters['imo'] = requestParameters.imo;
        }

        if (requestParameters.mmsi !== undefined) {
            queryParameters['mmsi'] = requestParameters.mmsi;
        }

        if (requestParameters.begin !== undefined) {
            queryParameters['begin'] = (requestParameters.begin as any).toISOString();
        }

        if (requestParameters.end !== undefined) {
            queryParameters['end'] = (requestParameters.end as any).toISOString();
        }

        const headerParameters: runtime.HTTPHeaders = {};

        if (this.configuration && (this.configuration.username !== undefined || this.configuration.password !== undefined)) {
            headerParameters["Authorization"] = "Basic " + btoa(this.configuration.username + ":" + this.configuration.password);
        }
        const response = await this.request({
            path: `/port/calls`,
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => PortCallsGet200ResponseFromJSON(jsonValue));
    }

    /**
     * Get a list of port calls for one or more ports or a vessel. Notice that at least one of the parameters mmsi, imo or locode must be provided 
     * Get a list port calls for a given port or vessel
     */
    async portCallsGet(requestParameters: PortCallsGetRequest = {}, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<PortCallsGet200Response> {
        const response = await this.portCallsGetRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * Get history of ships arriving at port. Use parameters to further define the time period
     * Get history of ships arriving at port
     */
    async portHistoryNameGetRaw(requestParameters: PortHistoryNameGetRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<PortHistoryNameGet200Response>> {
        if (requestParameters.name === null || requestParameters.name === undefined) {
            throw new runtime.RequiredError('name','Required parameter requestParameters.name was null or undefined when calling portHistoryNameGet.');
        }

        const queryParameters: any = {};

        if (requestParameters.begin !== undefined) {
            queryParameters['begin'] = (requestParameters.begin as any).toISOString();
        }

        if (requestParameters.end !== undefined) {
            queryParameters['end'] = (requestParameters.end as any).toISOString();
        }

        const headerParameters: runtime.HTTPHeaders = {};

        if (this.configuration && (this.configuration.username !== undefined || this.configuration.password !== undefined)) {
            headerParameters["Authorization"] = "Basic " + btoa(this.configuration.username + ":" + this.configuration.password);
        }
        const response = await this.request({
            path: `/port/history/{name}`.replace(`{${"name"}}`, encodeURIComponent(String(requestParameters.name))),
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => PortHistoryNameGet200ResponseFromJSON(jsonValue));
    }

    /**
     * Get history of ships arriving at port. Use parameters to further define the time period
     * Get history of ships arriving at port
     */
    async portHistoryNameGet(requestParameters: PortHistoryNameGetRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<PortHistoryNameGet200Response> {
        const response = await this.portHistoryNameGetRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * Delete a port by id
     * Delete a port
     */
    async portInfoIdDeleteRaw(requestParameters: PortInfoIdDeleteRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<StandardResponse>> {
        if (requestParameters.id === null || requestParameters.id === undefined) {
            throw new runtime.RequiredError('id','Required parameter requestParameters.id was null or undefined when calling portInfoIdDelete.');
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        if (this.configuration && (this.configuration.username !== undefined || this.configuration.password !== undefined)) {
            headerParameters["Authorization"] = "Basic " + btoa(this.configuration.username + ":" + this.configuration.password);
        }
        const response = await this.request({
            path: `/port/info/{id}`.replace(`{${"id"}}`, encodeURIComponent(String(requestParameters.id))),
            method: 'DELETE',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => StandardResponseFromJSON(jsonValue));
    }

    /**
     * Delete a port by id
     * Delete a port
     */
    async portInfoIdDelete(requestParameters: PortInfoIdDeleteRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<StandardResponse> {
        const response = await this.portInfoIdDeleteRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * Get extented port information
     * Get extented port information
     */
    async portInfoIdGetRaw(requestParameters: PortInfoIdGetRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<PortExtended>> {
        if (requestParameters.id === null || requestParameters.id === undefined) {
            throw new runtime.RequiredError('id','Required parameter requestParameters.id was null or undefined when calling portInfoIdGet.');
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        if (this.configuration && (this.configuration.username !== undefined || this.configuration.password !== undefined)) {
            headerParameters["Authorization"] = "Basic " + btoa(this.configuration.username + ":" + this.configuration.password);
        }
        const response = await this.request({
            path: `/port/info/{id}`.replace(`{${"id"}}`, encodeURIComponent(String(requestParameters.id))),
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => PortExtendedFromJSON(jsonValue));
    }

    /**
     * Get extented port information
     * Get extented port information
     */
    async portInfoIdGet(requestParameters: PortInfoIdGetRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<PortExtended> {
        const response = await this.portInfoIdGetRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * Update port with extended information
     * Update port information
     */
    async portInfoIdPutRaw(requestParameters: PortInfoIdPutRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<PortExtended>> {
        if (requestParameters.id === null || requestParameters.id === undefined) {
            throw new runtime.RequiredError('id','Required parameter requestParameters.id was null or undefined when calling portInfoIdPut.');
        }

        if (requestParameters.portExtended === null || requestParameters.portExtended === undefined) {
            throw new runtime.RequiredError('portExtended','Required parameter requestParameters.portExtended was null or undefined when calling portInfoIdPut.');
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        headerParameters['Content-Type'] = 'application/json';

        if (this.configuration && (this.configuration.username !== undefined || this.configuration.password !== undefined)) {
            headerParameters["Authorization"] = "Basic " + btoa(this.configuration.username + ":" + this.configuration.password);
        }
        const response = await this.request({
            path: `/port/info/{id}`.replace(`{${"id"}}`, encodeURIComponent(String(requestParameters.id))),
            method: 'PUT',
            headers: headerParameters,
            query: queryParameters,
            body: PortExtendedToJSON(requestParameters.portExtended),
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => PortExtendedFromJSON(jsonValue));
    }

    /**
     * Update port with extended information
     * Update port information
     */
    async portInfoIdPut(requestParameters: PortInfoIdPutRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<PortExtended> {
        const response = await this.portInfoIdPutRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * Create a new port with extended information
     * Create a new port
     */
    async portInfoPostRaw(requestParameters: PortInfoPostRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<PortExtended>> {
        if (requestParameters.portExtended === null || requestParameters.portExtended === undefined) {
            throw new runtime.RequiredError('portExtended','Required parameter requestParameters.portExtended was null or undefined when calling portInfoPost.');
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        headerParameters['Content-Type'] = 'application/json';

        if (this.configuration && (this.configuration.username !== undefined || this.configuration.password !== undefined)) {
            headerParameters["Authorization"] = "Basic " + btoa(this.configuration.username + ":" + this.configuration.password);
        }
        const response = await this.request({
            path: `/port/info`,
            method: 'POST',
            headers: headerParameters,
            query: queryParameters,
            body: PortExtendedToJSON(requestParameters.portExtended),
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => PortExtendedFromJSON(jsonValue));
    }

    /**
     * Create a new port with extended information
     * Create a new port
     */
    async portInfoPost(requestParameters: PortInfoPostRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<PortExtended> {
        const response = await this.portInfoPostRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * Get a list of ports based on a search pattern
     * Search for a port or list all ports
     */
    async portListGetRaw(requestParameters: PortListGetRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<PortListGet200Response>> {
        const queryParameters: any = {};

        if (requestParameters.pattern !== undefined) {
            queryParameters['pattern'] = requestParameters.pattern;
        }

        if (requestParameters.offset !== undefined) {
            queryParameters['offset'] = requestParameters.offset;
        }

        if (requestParameters.limit !== undefined) {
            queryParameters['limit'] = requestParameters.limit;
        }

        if (requestParameters.dc !== undefined) {
            queryParameters['_dc'] = requestParameters.dc;
        }

        if (requestParameters.nextport !== undefined) {
            queryParameters['nextport'] = requestParameters.nextport;
        }

        const headerParameters: runtime.HTTPHeaders = {};

        if (this.configuration && (this.configuration.username !== undefined || this.configuration.password !== undefined)) {
            headerParameters["Authorization"] = "Basic " + btoa(this.configuration.username + ":" + this.configuration.password);
        }
        const response = await this.request({
            path: `/port/list`,
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => PortListGet200ResponseFromJSON(jsonValue));
    }

    /**
     * Get a list of ports based on a search pattern
     * Search for a port or list all ports
     */
    async portListGet(requestParameters: PortListGetRequest = {}, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<PortListGet200Response> {
        const response = await this.portListGetRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * Delete a ship in the ship register with the given mmsi.
     * Delete a ship in the ship register.
     */
    async shipRegisterMmsiDeleteRaw(requestParameters: ShipRegisterMmsiDeleteRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<ShipRegisterGet200Response>> {
        if (requestParameters.mmsi === null || requestParameters.mmsi === undefined) {
            throw new runtime.RequiredError('mmsi','Required parameter requestParameters.mmsi was null or undefined when calling shipRegisterMmsiDelete.');
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        if (this.configuration && (this.configuration.username !== undefined || this.configuration.password !== undefined)) {
            headerParameters["Authorization"] = "Basic " + btoa(this.configuration.username + ":" + this.configuration.password);
        }
        const response = await this.request({
            path: `/ship/register/{mmsi}`.replace(`{${"mmsi"}}`, encodeURIComponent(String(requestParameters.mmsi))),
            method: 'DELETE',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => ShipRegisterGet200ResponseFromJSON(jsonValue));
    }

    /**
     * Delete a ship in the ship register with the given mmsi.
     * Delete a ship in the ship register.
     */
    async shipRegisterMmsiDelete(requestParameters: ShipRegisterMmsiDeleteRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<ShipRegisterGet200Response> {
        const response = await this.shipRegisterMmsiDeleteRaw(requestParameters, initOverrides);
        return await response.value();
    }

}
